import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import style from "../OrderInfoExpeditor.module.scss";
import LightningBoldIcon from "../../../shared/icons/LightningBoldIcon";
import LocationIconNew from "../../../shared/icons/LocationIconNew";
import UsersIcon from "../../../shared/icons/UsersIcon";
import ContractIcon from "../../../shared/icons/ContractIcon";
import ClockIcon from "../../../shared/icons/ClockIcon";

const TABS = [
  { key: "actions", labelKey: "actions", Icon: LightningBoldIcon, iconSize: 16 },
  { key: "route", labelKey: "route", Icon: LocationIconNew, iconSize: 18 },
  { key: "executor", labelKey: "executor", Icon: UsersIcon, iconSize: 18, countProp: "executorCount" },
  { key: "documents", labelKey: "documents", Icon: ContractIcon, iconSize: 18, countProp: "documentsCount" },
  { key: "history", labelKey: "history", Icon: ClockIcon, iconSize: 18 },
];

const OrderInfoExpeditorTabs = ({ activeTab, onTabChange, executorCount = 0, documentsCount = 0, isWithoutExecutor = false }) => {
  const { t } = useTranslation();
  const getCount = (countProp) => {
    if (countProp === "executorCount") return executorCount;
    if (countProp === "documentsCount") return documentsCount;
    return 0;
  };

  const visibleTabs = isWithoutExecutor ? TABS.filter((tab) => tab.key !== "executor") : TABS;

  return (
    <div className={style.tabs}>
      <div className={style.tabs_list}>
        {visibleTabs.map((tab) => {
          const count = tab.countProp ? getCount(tab.countProp) : 0;
          return (
            <div
              key={tab.key}
              className={cn(style.tabs_item, { [style.tabs_item_active]: activeTab === tab.key })}
              onClick={() => onTabChange(tab.key)}
            >
              <tab.Icon
                width={tab.iconSize}
                height={tab.iconSize}
                fill={activeTab === tab.key ? "#0D3B66" : "#6D7885"}
                color={activeTab === tab.key ? "#0D3B66" : "#6D7885"}
                type={1}
              />
              <span>{t(`orderInfoExpeditor.tabs.${tab.labelKey}`)}</span>
              {count > 0 && <div className={style.tabs_badge}>{count}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderInfoExpeditorTabs;
